<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

// 返回上一页
const goBack = () => {
  router.go(-1)
}

// 跳转首页
const goHome = () => {
  router.push('/')
}
</script>

<template>

    <div class="not-found-container">
      <!-- 背景装饰 -->
      <div class="background">
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
      </div>

      <!-- 主要内容 -->
      <div class="content">
        <!-- 迷路的小龟谷吉祥物 SVG -->
        <div class="turtle-container">
          <svg class="turtle" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <circle cx="100" cy="100" r="80" fill="#409eff" opacity="0.1"/>
            <circle cx="100" cy="100" r="60" fill="#409eff" opacity="0.2"/>
            <!-- 小龟谷身体 -->
            <ellipse cx="100" cy="110" rx="40" ry="30" fill="#8ECA94"/>
            <!-- 头部 -->
            <circle cx="100" cy="70" r="15" fill="#A5D6A0"/>
            <!-- 眼睛 -->
            <circle cx="93" cy="68" r="5" fill="#fff"/>
            <circle cx="107" cy="68" r="5" fill="#fff"/>
            <circle cx="93" cy="68" r="2" fill="#000"/>
            <circle cx="107" cy="68" r="2" fill="#000"/>
            <!-- 迷茫的问号 -->
            <text x="100" y="130" font-size="24" text-anchor="middle" fill="#409eff" font-weight="bold">?</text>
          </svg>
        </div>

        <!-- 文案区域 -->
        <div class="text-content">
          <h1>404</h1>
          <h2>哎呀，小龟谷迷路啦！</h2>
          <p>您要找的页面暂时找不到，可能已被移动或删除。</p>

          <!-- 操作按钮 -->
          <div class="actions">
            <button class="btn primary" @click="goBack">
              <i class="icon-arrow-left"></i> 返回上一页
            </button>
            <button class="btn secondary" @click="goHome">
              <i class="icon-home"></i> 回到首页
            </button>
          </div>

          <!-- 联系支持 -->
          <div class="support">
            <p>需要帮助？请联系我们的客服老师：<br>
              <strong>service@haigui-edu.com</strong></p>
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped >
  .not-found-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
    font-family: 'Arial', 'Microsoft YaHei', sans-serif;
    position: relative;
    overflow: hidden;
  }

  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
  }

  .wave {
    position: absolute;
    border-radius: 40%;
    background: rgba(64, 158, 255, 0.05);
    filter: blur(40px);
  }

  .wave:nth-child(1) {
    width: 50vh;
    height: 50vh;
    left: 20%;
    top: 40%;
    animation: drift 8s infinite linear;
  }

  .wave:nth-child(2) {
    width: 40vh;
    height: 40vh;
    left: 70%;
    top: 20%;
    animation: drift 10s infinite linear reverse;
  }

  .wave:nth-child(3) {
    width: 30vh;
    height: 30vh;
    left: 40%;
    top: 70%;
    animation: drift 12s infinite linear;
  }

  @keyframes drift {
    0% { transform: translate(0, 0) rotate(0deg); }
    100% { transform: translate(100px, 100px) rotate(360deg); }
  }

  .content {
    position: relative;
    z-index: 1;
    text-align: center;
    padding: 20px;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .turtle-container {
    margin-bottom: 30px;
    animation: float 4s ease-in-out infinite;
  }

  .turtle {
    width: 150px;
    height: 150px;
  }

  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }

  .text-content h1 {
    font-size: 72px;
    color: #409eff;
    margin: 0;
    font-weight: bold;
    text-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .text-content h2 {
    font-size: 28px;
    color: #333;
    margin: 10px 0;
    font-weight: 500;
  }

  .text-content p {
    color: #666;
    font-size: 16px;
    line-height: 1.6;
    margin: 20px 0;
  }

  .actions {
    margin: 30px 0;
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .btn {
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn.primary {
    background: #409eff;
    color: white;
  }

  .btn.primary:hover {
    background: #2c7be5;
    transform: translateY(-2px);
  }

  .btn.secondary {
    background: white;
    color: #409eff;
    border: 2px solid #409eff;
  }

  .btn.secondary:hover {
    background: #f0f7ff;
    transform: translateY(-2px);
  }

  .support {
    margin-top: 20px;
    color: #999;
    font-size: 14px;
    text-align: center;
  }

  .support strong {
    color: #409eff;
    font-weight: 600;
  }

  /* 响应式 */
  @media (max-width: 768px) {
    .text-content h1 {
      font-size: 56px;
    }
    .text-content h2 {
      font-size: 24px;
    }
    .turtle {
      width: 120px;
      height: 120px;
    }
    .btn {
      padding: 10px 20px;
      font-size: 15px;
    }
  }

  @media (max-width: 480px) {
    .actions {
      flex-direction: column;
      align-items: center;
    }
    .btn {
      width: 100%;
      max-width: 280px;
    }
  }
</style>